import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { safelyParseJSON } from 'core/util';

@inject('$dictionary', '$setup')
@observer
class Dismissible extends Component {
  get sessionStorageKey() {
    const { name, $dictionary } = this.props;
    return `kentik_${$dictionary.dictionary.envName}_${name}_hidden`;
  }

  get preferenceKey() {
    const { name } = this.props;
    return `dismissible_${name}_hidden`;
  }

  constructor(props) {
    super(props);

    const { $setup, name } = props;

    // Originally this was in sessionStorage, this will preserve that selection
    let isHidden = $setup.getSettings(this.preferenceKey);
    if (isHidden === undefined) {
      isHidden = safelyParseJSON(window.sessionStorage[this.sessionStorageKey]);
    }

    if (isHidden) {
      $setup.dismissedCallouts.add(name);
    }
  }

  handleDismiss = () => {
    const { $setup, name, noPersist } = this.props;
    $setup.dismissedCallouts.add(name);
    if (!noPersist) {
      $setup.updateSettings({ [this.preferenceKey]: true });
    }
  };

  render() {
    const { $setup, name, children } = this.props;
    const isOpen = !$setup.dismissedCallouts.has(name);

    if (!isOpen) {
      return false;
    }

    return children({ onDismiss: this.handleDismiss });
  }
}

export default Dismissible;
